import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import { Link, useNavigate, useLocation, NavLink } from "react-router-dom";
import Footer from "../components/Footer";

import Loader from "../views/admin/Common/Loader";
import { Row, Col } from "react-bootstrap";
import { CFormSelect } from "@coreui/react";

import "../assets/css/Home/style.css";
import main_logo from "../assets/images/UPG_site_logo.png";
import slide_img_new1 from "../assets/images/what_makes_us_ different/level_playing_field.png";
import slide_img_new2 from "../assets/images/what_makes_us_ different/track_your_triumphs.jpg";
import slide_img_new3 from "../assets/images/slide_img_new3.png";
import slide_img_new4 from "../assets/images/what_makes_us_ different/accurate_scoring.jpg";
import slide_img_new5 from "../assets/images/what_makes_us_ different/every_match_counts.jpg";
import slide_img_new6 from "../assets/images/what_makes_us_ different/play_in_style.jpg";

import tabs1_content_img from "../assets/images/home/tabs1_content_img.svg";
import bandminton_img from "../assets/images/home/bandminton.png";
import table_tennis_img from "../assets/images/home/table_tennis.png";
import cancer_counsil from "../assets/images/home/cancer_counsil.png";
// import cancer_council_vic from '../assets/images/home/cancer_council_vic.jpeg';
import tabs_content_people_play_img from "../assets/images/home/tabs_content_people_play_img.svg";
import quality_tab2_icon from "../assets/images/home/quality_tab2_icon.svg";
import Healthy_tab2_icon from "../assets/images/home/Healthy_tab2_icon.svg";
import tennis_bat from "../assets/images/home/tennis_bat.svg";
import Tennis_peole_play from "../assets/images/home/Tennis_peole_play.svg";
import tournament_cart_img1 from "../assets/images/tournament _details/badminton.jpg";
import tournament_cart_img2 from "../assets/images/tournament _details/bowling.jpg";
import tournament_cart_img3 from "../assets/images/tournament _details/table_tennis_n.png";
import tournament_cart_img4 from "../assets/images/tournament _details/2k_run_1.png";
import Bragging_tab_icon from "../assets/images/home/tabs_icons/Bragging_tab_icon.svg";
import charity_tab_icon from "../assets/images/home/tabs_icons/charity_tab_icon.svg";
import Networking_tab_icon from "../assets/images/home/tabs_icons/Networking_tab_icon.svg";
import office_tab_icon from "../assets/images/home/tabs_icons/office_tab_icon.svg";
import Productivity_tab_icon from "../assets/images/home/tabs_icons/Productivity_tab_icon.svg";
import Visibility_tab_icon from "../assets/images/home/tabs_icons/Visibility_tab_icon.svg";
import calender_icon_info from "../assets/images/home/tuornament_icons/calender_icon_info.svg";
import game_icon_info from "../assets/images/home/tuornament_icons/game_icon_info.svg";
import location_icon_cart from "../assets/images/home/tuornament_icons/location_icon_cart.svg";
import locatioon_icon_info from "../assets/images/home/tuornament_icons/locatioon_icon_info.svg";
import user_icon_cart from "../assets/images/home/tuornament_icons/user_icon_cart.svg";
import user_icon_info from "../assets/images/home/tuornament_icons/user_icon_info.svg";
import calendar_icon_cart from "../assets/images/home/tuornament_icons/calendar_icon_cart.svg";
import dummy_teamlogo from "../assets/logo.png";
import { Profile, FetchAllPoints, PhotoAPI } from "../API/player";
import {
  GetFaq,
  GetTournaments,
  FilterDynamicText,
  getSetting,
  getpdfs,
} from "../API/admin";
import { GetTeams } from "../API/auth";
import Swal from "sweetalert2";
import { useSnackbar } from "notistack";
import { FormatDate } from "../Common/CommonFunction";
import { use } from "react";
import MyCarousel from "./carrosel";
import noun_medal from "../assets/images/home/noun-medal.svg";
import noun_money_bag from "../assets/images/home/noun-money-bag.svg";
import noun_networking from "../assets/images/home/noun-networking.svg";
import noun_bright_star from "../assets/images/home/noun_bright_star.svg";
import noun_muscle from "../assets/images/home/noun_muscle.svg";
import { CountUp } from "use-count-up";
const PDF_URL = process.env.REACT_APP_PDF_MY_ENVIRONMENT_VARIABLE;

export const Home = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loginUser, setLoginUser] = useState(null);
  const [dynamicHeading, setDynamicHeading] = useState({});

  const [allFaq, setallFaq] = useState([]);
  let [loaderStatus, setloaderStatus] = useState(true);
  const [CorporateList, setCorporateList] = useState([]);
  const [teams, setTeams] = useState([]);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [Tournament, setTournament] = useState([]);
  const [TournamentOff, setTouramentOff] = useState(false);
  const navigate = useNavigate();

  const [allPDF, setallPdf] = useState([]);

  const IMAGE_URL = process.env.REACT_APP_IMAGE_MY_ENVIRONMENT_VARIABLE;
  useEffect(() => {
    let callAPI = async () => {
      let res = await getSetting();

      if (res.status) {
        res.data.map((entry, index) => {
          if (entry.value == "false" && entry.name === "tournament_register") {
            setTouramentOff(true);
          }
        });
      } else {
        // setIsOn(null);
        enqueueSnackbar("unable to fetch setting", {
          variant: "error",
          action: (key) => (
            <button
              className="toast_close_btn"
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    };
    callAPI();
  }, []);

  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      if (res && res.statusCode == 403) {
        setLoginUser(null);
        setloaderStatus(false);
      } else {
        setLoginUser(res.data);
        setloaderStatus(false);
      }
    };

    let getfaqAPI = async () => {
      let res = await GetFaq();
      if (res && res.status) {
        setallFaq(res.data);
      } else {
        setallFaq([]);
      }
    };

    let getALLTournamentAPI = async () => {
      // make it dynamic acording to city
      let res = await GetTournaments();
      if (res && res.status) {
        setSelectedTournament(res.data[0].name);
      } else {
        setSelectedTournament(null);
      }
    };
    let getTeamsAPI = async () => {
      let res = await GetTeams();
      if (res.status) {
        setTeams(res.data);
      } else {
        setTeams([]);
      }
    };
    getTeamsAPI();
    callAPI();
    getfaqAPI();
    getALLTournamentAPI();
    // FetchAllPointsAPi()
  }, []);

  useEffect(() => {
    let getTournamentAPI = async () => {
      // make it dynamic acording to city
      let res = await GetTournaments({ data: selectedTournament });

      if (res.status) {
        setTournament(res.data);
      }
    };
    if (selectedTournament != null) {
      getTournamentAPI();
    }
  }, [selectedTournament]);

  //  Photo/Video Request hit
  useEffect(() => {
    let callAPIDynamictext = async () => {
      let formData = {
        data: null,
      };
      let res = await FilterDynamicText(formData);
      if (res.data.status) {
        setDynamicHeading(res.data.data);
      }
    };
    callAPIDynamictext();
  }, []);

  useEffect(() => {
    const callAPI = async () => {
      let res = await getpdfs();
      if (res.status) {
        setallPdf(res.data); // Set the original PDFs
      }
    };
    callAPI();
  }, []);
  let PhotoReq = async () => {
    Swal.fire({
      title: dynamicHeading.request_photo_video
        ? dynamicHeading.request_photo_video.title
        : "Request photo/video?",
      text: dynamicHeading.request_photo_video
        ? dynamicHeading.request_photo_video.value
        : "Request photo/video?",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send Request",
      cancelButtonText: "Close",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await PhotoAPI();
        if (res.data.status) {
          if (res.data.NoMatch) {
            enqueueSnackbar("You have not played any matches yet", {
              variant: "error",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          } else {
            enqueueSnackbar("Request was sent successfully", {
              variant: "success",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          }
        } else {
          enqueueSnackbar("Unable to send request at the moment", {
            variant: "error",
            action: (key) => (
              <button
                className="toast_close_btn"
                onClick={() => {
                  // Close the Snackbar
                  closeSnackbar(key);
                }}
              >
                X
              </button>
            ),
          });
        }
      }
    });
  };

  //    My profile navigation
  let Myprofilenavigate;
  if (loginUser) {
    switch (loginUser.role) {
      case "participant":
        Myprofilenavigate = "/participant/profile";
        break;
      case "admin":
        Myprofilenavigate = "/admin/profile";
        break;
      case "scorer":
        Myprofilenavigate = "/scorer/profile";
        break;
      default:
        Myprofilenavigate = "/";
        break;
    }
  } else {
    Myprofilenavigate = "/"; // Redirect to login if user is not logged in
  }

  return (
    <>
      {loaderStatus ? <Loader /> : null}

      <div className="home_main">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light pt-3 pb-2 px-5 head_nav_landingpage">
            <a className="navbar-brand" href="/">
              <img src={main_logo} alt="Logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{ background: "#B2022F" }}
            >
              {/* <span className="navbar-toggler-icon" /> */}
              <i
                class="bi bi-list"
                style={{ color: "#fff", fontSize: "25px" }}
              ></i>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto nav-list">
                {loginUser != null ? (
                  <>
                    <li className="nav-item">
                      <a
                        className="nav_page_btn"
                        href="/"
                        style={{
                          fontWeight: 700,
                          color: "#b2022f",
                        }}
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="nav-item"
                      style={{ display: loginUser != null ? "block" : "none" }}
                    >
                      <NavLink
                        className="nav_page_btn mobile_displa_dashboard"
                        to="/dashboard"
                        activeClassName="active"
                      >
                        Dashboard
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/Results"
                        activeClassName="active"
                      >
                        Results
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/photo-gallery"
                        activeClassName="active"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/contact"
                        activeClassName="active"
                      >
                        Get in Touch
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={
                            loginUser.profile_image !== undefined
                              ? IMAGE_URL + "user/" + loginUser.profile_image
                              : IMAGE_URL + "blank_user.png"
                          }
                          alt="Profile"
                          className="rounded-circle"
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                          }}
                        />
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end new_header_dropdown"
                        aria-labelledby="navbarDropdown"
                      >
                        <li className="mobile_displa_popup_dashboard">
                          <NavLink className="dropdown-item" to="/dashboard">
                            Dashboard
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="dropdown-item"
                            to={Myprofilenavigate}
                          >
                            My Profile
                          </NavLink>
                        </li>
                        <li
                          style={{
                            display:
                              loginUser.role === "participant"
                                ? "block"
                                : "none",
                          }}
                          onClick={() => PhotoReq()}
                        >
                          <Link className="dropdown-item">
                            {" "}
                            Request Photo/Video
                          </Link>
                        </li>
                        <li>
                          <Link className="dropdown-item" to="/logout">
                            Logout
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="nav-item">
                      <a
                        className="nav_page_btn"
                        href="/"
                        style={{
                          fontWeight: 700,
                          color: "#b2022f",
                        }}
                      >
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/Results"
                        activeClassName="active"
                      >
                        Results
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/photo-gallery"
                        activeClassName="active"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav_page_btn"
                        to="/contact"
                        activeClassName="active"
                      >
                        Get in Touch
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      {/* Changed to NavLink */}
                      <NavLink
                        className="signup_btn"
                        to="/register"
                        activeClassName="active"
                      >
                        Register Now
                      </NavLink>
                    </li>

                    <li className="nav-item">
                      <NavLink
                        className="login_btn"
                        to="/login"
                        activeClassName="active"
                      >
                        Login
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </nav>
        </header>
        <section className="headre_bg_div"></section>
        <div className="banner">
          <ReactPlayer
            url={require("../assets/banner_video.mp4")}
            playing
            loop
            muted
            width="100%"
            height="100%"
            className="video_player"
            // style={{objectFit: 'cover'}}
          />
          <div className="overlay_banner"></div>
          <div className="content_banner">
            <div className="container  text-center py-5">
              <h1 className="text-white head_bnner_tagline">
                {/* PUSH YOUR LIMITS, OWN THE GAME */}
                WELCOME TO THE UNITED PREMIER GAMES <br />
              </h1>
              <p className="py-3 hero_Section_registration">
                Get involved in this epic multi-sport event! <br />
              </p>

              {loginUser == null && TournamentOff == false ? (
                <>
                  <p className="text-white hero_Section_registration">
                    {/* Registrations are now open in Melbourne! */}
                    Register now and join in on the action!
                  </p>
                  <button
                    className="header_sign_btn mt-3"
                    onClick={() => navigate("/register")}
                  >
                    Register Now
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </div>
        {/* <section className="container-fluid head_banner_sec py-5 ">
                </section> */}
        <section className="container-fluid about_main_sec py-5 ">
          <div className="container">
            <div className="row">
              <div className=" col-12 text-white about_us">
                <h2 className="fw-bold new_all_common_heading"> ABOUT US</h2>
                {/* <h3> What are the United Premier Games?</h3> */}
                {/* <p className='py-2'>
                                    {" "}
                                    Welcome to the <b> Welcome to the United Premier Games, </b> a multi-sport tournament that brings neighbourhoods together for an unforgettable sporting experience. Represent your suburb and challenge your skills as you compete for victory in this exciting showdown!
                                </p> 
                                <p className='py-2'>
                                Whether you’re a seasoned athlete or driven by the thrill of competition, this tournament offers the perfect opportunity to showcase your talent, build connections, and embrace the spirit of sport. Participants can choose their team and compete in their preferred sport(s), with each victory contributing to both their individual success as well as their team’s overall success!
                                </p>
                                <p className='py-2'>
                                The <b>Tournament Details</b> and <b>Team Details</b> sections below provide comprehensive information about the sports, venues, dates, and teams.
                                </p>
                                <p className='py-2'>
                                   <b> Get ready to push your limits and own the game!</b>
                                </p> */}
                <p className="py-2">
                  {" "}
                  Welcome to the <b> United Premier Games</b>, a multi-sport
                  event uniting neighbourhoods for an exciting and memorable
                  experience! Represent your suburb, challenge yourself, and
                  celebrate the joy of sport. Choose your game - Table Tennis,
                  Badminton, or both, and join the action!
                </p>
              </div>
              {/* <div className=" col-lg-2 col-0" ></div>
                            <div className="col-lg-5 col-12">
                                <div className="about_img_col">
                                    <img
                                        src={tennis_bat}
                                        className="bat_img_about"
                                        alt="tennis bat"
                                    />
                                    <img
                                        src={Tennis_peole_play}
                                        className="play_img_about"
                                        alt="play"
                                    />
                                </div>
                            </div> */}
            </div>
          </div>
        </section>
        <section className="container-fluid tabs_main_sec pb-5 ">
          <div className="container">
            <div className="row py-4 ">
              <div className="col-lg-4 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-11 text-white custom-padding-why-join">
                      <b>
                        <h1>Guaranteed games</h1>
                        <h1 style={{ fontFamily: "math" }}>
                          <CountUp isCounting end={5} duration={1} />
                        </h1>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-11 text-white custom-padding-why-join">
                      <b>
                        <h1>Prize pool</h1>
                        <h1 style={{ fontFamily: "math" }}>
                          $<CountUp isCounting end={7000} duration={1} />
                        </h1>
                      </b>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-11 text-white custom-padding-why-join">
                      <b>
                        <h1>Gift cards</h1>
                        <h1 style={{ fontFamily: "math" }}>
                          $<CountUp isCounting end={1400} duration={1} />
                        </h1>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container-fluid tabs_main_sec pb-5 ">
          <div className="container">
            <div className="row py-4 ">
              <div className="col-lg-4 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-11 text-white custom-padding-why-join">
                      <b>
                        <h1>1st place</h1>
                        <h1 style={{ fontFamily: "math" }}>
                          $<CountUp isCounting end={1000} duration={1} />
                        </h1>
                      </b>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-11 text-white custom-padding-why-join">
                      <b>
                        <h1>2nd place</h1>
                        <h1 style={{ fontFamily: "math" }}>
                          $<CountUp isCounting end={500} duration={1} />
                        </h1>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-11 text-white custom-padding-why-join">
                      <b>
                        <h1>3rd place</h1>
                        <h1 style={{ fontFamily: "math" }}>
                          $<CountUp isCounting end={250} duration={1} />
                        </h1>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="container-fluid tabs_main_sec pb-5 ">
          <div className="container">
            <div className="row py-4 ">
              <div className="col-lg-12 text-white">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div class="d-flex align-items-start mt-4 mb-3">
                      <span
                        style={{
                          color: "orange",
                          fontWeight: "bold",
                          marginRight: "2px",
                          fontSize: "14px",
                        }}
                      >
                        *
                      </span>
                      <p
                        class="text-white mb-0 mobile-side-font"
                        style={{ fontSize: "14px", marginTop: "-1px" }}
                      >
                        Download the rules and tournament structure from
                        tournament details section for more information.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/*  */}
        <section className="container-fluid slider_block pt-2 pb-5 ">
          <div className="container">
            <h3 className="fw-bold text-white pb-3 new_all_common_heading">
              {" "}
              WHAT MAKES US DIFFERENT?
            </h3>
            <div className="row">
              <div className="large-12 columns">
                {/* <div className="owl-carousel owl-theme cpl-carousel">
                                    <div className="item">
                                        <div className="slider_card">
                                            <div className='slider_img_div'>
                                                <img src={slide_img_new1} alt="img" />
                                            </div>
                                            <div className='slider_content'>
                                                <div className='content_div_heading'>Level Playing Field
                                                </div>
                                                <div className='content_div_text'>
                                                We ensure a level playing field with equal representation from every suburb, giving everyone a shot at glory!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="slider_card">
                                            <div className='slider_img_div'>
                                                <img src={slide_img_new3} alt="img" />
                                            </div>
                                            <div className='slider_content'>
                                                <div className='content_div_heading'>Built on Professionalism
                                                </div>
                                                <div className='content_div_text'>
                                                Experience a tournament run with the highest standards of professionalism, where every game celebrates the community and competitive spirit!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="slider_card">
                                            <div className='slider_img_div'>
                                                <img src={slide_img_new2} alt="img" />
                                            </div>
                                            <div className='slider_content'>
                                                <div className='content_div_heading'> Track Your Triumphs
                                                </div>
                                                <div className='content_div_text'>
                                                Stay ahead with our cutting-edge web app, designed to help you monitor your stats like a pro and track your growth throughout the tournament!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="slider_card">
                                            <div className='slider_img_div'>
                                                 <img src={slide_img_new4} alt="img" />
                                            </div>
                                            <div className='slider_content'>
                                                <div className='content_div_heading'> Accurate Scoring
                                                </div>
                                                <div className='content_div_text'>
                                                Enjoy the confidence of fair play with precise scoring for every match, ensuring a tournament that leaves you fulfilled!
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item">
                                        <div className="slider_card">
                                            <div className='slider_img_div'>
                                                <img src={slide_img_new5} alt="img" />
                                            </div>
                                            <div className='slider_content'>
                                                <div className='content_div_heading'> Every Match Counts
                                                </div>
                                                <div className='content_div_text'>
                                                Our points system ensures that every strong performance you deliver contributes directly to your team's success, making each effort truly impactful!
                                                    </div>
                                            </div>
                                        </div>
                                    </div>

                           

                                    <div className="item">
                                        <div className="slider_card">
                                            <div className='slider_img_div'>
                                                <img src={slide_img_new6} alt="img" />
                                            </div>
                                            <div className='slider_content'>
                                                <div className='content_div_heading'>Play in Style
                                                </div>
                                                <div className='content_div_text'>
                                                Compete in state-of-the-art venues that enhance your tournament experience and let your skills shine!
                                                    </div>
                                            </div>
                                        </div>
                                    </div>

                                    
                                </div> */}
                <MyCarousel />
              </div>
            </div>
          </div>
        </section>
        <section className="container-fluid tabs_main_sec pb-5 ">
          <div className="container">
            <h3 className="text-white mt-2 new_all_common_heading">
              WHY JOIN THE UNITED PREMIER GAMES?
            </h3>
            <div className="row py-4 ">
              <div className="col-lg-6 text-white">
                <div className="tabs_img_div">
                  <img
                    src={tabs1_content_img}
                    className="large_tab_img"
                    alt="tennis bat"
                  />
                  <img
                    src={tabs_content_people_play_img}
                    className="small_tab_img"
                    alt="play"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="main_tab_right join_section">
                  <div className="row tab_right_block tab_content_row">
                    <div className="col-1">
                      {" "}
                      {/* <span className="tabs_icon_img"><svg width="24px" height="35px" viewBox="0 0 48 48" fill="white" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.37 36C22.82 30.75 27.89 27 33.73 27.62C39.29 28.21 43.71 32.9 43.99 38.48C44.06 39.95 43.86 41.36 43.43 42.67C43.17 43.47 42.39 44 41.54 44H11.7584C6.71004 44 2.92371 39.3814 3.91377 34.4311L9.99994 4H21.9999L25.9999 11L17.43 17.13L14.9999 14" stroke="#000000" stroke-width="4" stroke-miterlimit="2" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M17.4399 17.13L22 34" stroke="#000000" stroke-width="4" stroke-miterlimit="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg></span> */}
                      {/* <img
                                                src={Productivity_tab_icon}
                                                className="tabs_icon_img"
                                                alt="icon"
                                            /> */}
                      <img
                        height={30}
                        src={noun_muscle}
                        className="tabs_icon_img"
                        alt="icon"
                      />
                    </div>
                    <div className="col-11 text-white custom-padding-why-join">
                      {/* <b> Boost Your Well-Being:</b> Elevate your mental and physical health through the power of sport. Experience the energy and motivation that comes with pushing your limits and staying active! */}
                      <b> Stay active & have fun: </b> Elevate your mental and
                      physical health through the excitement of sport, staying
                      fit and having fun along the way!
                    </div>
                  </div>
                  <div className="row pt-3 tab_content_row">
                    <div className="col-1">
                      {" "}
                      {/* <span className="tabs_icon_img">

                                            <svg width="20px" height="35x" viewBox="0 0 24 24" stroke="white" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.43124 9.68927C6.20891 10.0388 6.31199 10.5023 6.66148 10.7246C7.01096 10.947 7.47451 10.8439 7.69685 10.4944L6.43124 9.68927ZM10.0407 7.77083L10.2729 8.48399L10.2739 8.48365L10.0407 7.77083ZM10.5456 8.40513C10.9473 8.30399 11.1909 7.89637 11.0898 7.4947C10.9886 7.09302 10.581 6.84939 10.1793 6.95054L10.5456 8.40513ZM7.69693 10.4943C7.91919 10.1447 7.81601 9.6812 7.46647 9.45894C7.11694 9.23669 6.65341 9.33986 6.43115 9.6894L7.69693 10.4943ZM7.08257 16.4498L7.71309 16.0437L7.71306 16.0437L7.08257 16.4498ZM9.57369 18.5668L9.27752 19.2559L9.27785 19.256L9.57369 18.5668ZM13.8227 18.5668L14.1186 19.256L14.1189 19.2559L13.8227 18.5668ZM16.3139 16.4498L15.6834 16.0437L15.6833 16.0437L16.3139 16.4498ZM16.9653 9.6894C16.743 9.33986 16.2795 9.23669 15.93 9.45894C15.5804 9.6812 15.4772 10.1447 15.6995 10.4943L16.9653 9.6894ZM6.42906 10.4909C6.64948 10.8416 7.11247 10.9472 7.46316 10.7268C7.81385 10.5064 7.91945 10.0434 7.69903 9.69272L6.42906 10.4909ZM3.97914 5.18383L3.34206 5.57962L3.34416 5.58295L3.97914 5.18383ZM3.94917 4.68259L4.62931 4.99868L4.62931 4.99868L3.94917 4.68259ZM4.34769 4.39083L4.43506 5.13574L4.43987 5.13515L4.34769 4.39083ZM7.47257 4.00383L7.56475 4.74815L7.5652 4.74809L7.47257 4.00383ZM7.94934 4.21783L8.56435 3.78856L8.56277 3.78632L7.94934 4.21783ZM9.74941 8.1071C9.98649 8.44676 10.454 8.52991 10.7937 8.29283C11.1333 8.05575 11.2165 7.58822 10.9794 7.24856L9.74941 8.1071ZM10.1783 6.9513C9.777 7.05412 9.53507 7.46275 9.63789 7.864C9.7407 8.26525 10.1493 8.50718 10.5506 8.40436L10.1783 6.9513ZM12.8459 8.40436C13.2471 8.50718 13.6557 8.26525 13.7585 7.864C13.8614 7.46275 13.6194 7.05412 13.2182 6.9513L12.8459 8.40436ZM15.6995 10.4952C15.9217 10.8448 16.3852 10.948 16.7348 10.7257C17.0843 10.5035 17.1875 10.04 16.9653 9.69043L15.6995 10.4952ZM13.3557 7.77083L13.1225 8.48365L13.1234 8.48396L13.3557 7.77083ZM13.2171 6.95054C12.8154 6.84939 12.4078 7.09302 12.3067 7.4947C12.2055 7.89637 12.4492 8.30399 12.8508 8.40513L13.2171 6.95054ZM15.6992 9.69395C15.4789 10.0447 15.5847 10.5077 15.9355 10.728C16.2862 10.9483 16.7492 10.8425 16.9695 10.4917L15.6992 9.69395ZM19.4173 5.18383L20.0524 5.58271L20.0535 5.58096L19.4173 5.18383ZM19.4479 4.68189L18.7677 4.99765L18.7677 4.99765L19.4479 4.68189ZM19.0487 4.38983L18.9568 5.13419L18.9623 5.13483L19.0487 4.38983ZM15.9239 4.00383L15.8312 4.74809L15.8319 4.74818L15.9239 4.00383ZM15.4471 4.21783L14.8337 3.78631L14.8321 3.78848L15.4471 4.21783ZM12.4171 7.24748C12.1799 7.5871 12.263 8.05465 12.6027 8.29178C12.9423 8.5289 13.4098 8.44581 13.647 8.10619L12.4171 7.24748ZM7.69685 10.4944C8.30647 9.53611 9.21768 8.82752 10.2729 8.48399L9.80854 7.05767C8.41664 7.51081 7.22457 8.44221 6.43124 9.68927L7.69685 10.4944ZM10.2739 8.48365C10.3633 8.45441 10.4538 8.42823 10.5456 8.40513L10.1793 6.95054C10.054 6.9821 9.93003 7.01792 9.80748 7.05802L10.2739 8.48365ZM6.43115 9.6894C5.04454 11.8701 5.0527 14.6838 6.45207 16.856L7.71306 16.0437C6.63068 14.3635 6.62428 12.1812 7.69693 10.4943L6.43115 9.6894ZM6.45204 16.856C7.13919 17.9228 8.12183 18.7591 9.27752 19.2559L9.86987 17.8778C8.99248 17.5007 8.24101 16.8633 7.71309 16.0437L6.45204 16.856ZM9.27785 19.256C10.826 19.9206 12.5705 19.9206 14.1186 19.256L13.5269 17.8776C12.3566 18.38 11.0399 18.38 9.86953 17.8776L9.27785 19.256ZM14.1189 19.2559C15.2746 18.7591 16.2572 17.9228 16.9444 16.856L15.6833 16.0437C15.1554 16.8633 14.404 17.5007 13.5266 17.8778L14.1189 19.2559ZM16.9444 16.856C18.3437 14.6838 18.3519 11.8701 16.9653 9.6894L15.6995 10.4943C16.7722 12.1812 16.7658 14.3635 15.6834 16.0437L16.9444 16.856ZM7.69903 9.69272L4.61413 4.78472L3.34416 5.58295L6.42906 10.4909L7.69903 9.69272ZM4.61621 4.78805C4.65654 4.85297 4.66065 4.93124 4.62931 4.99868L3.26904 4.36649C3.08785 4.75635 3.11461 5.21348 3.34207 5.57961L4.61621 4.78805ZM4.62931 4.99868C4.59724 5.06767 4.52714 5.12493 4.43506 5.13573L4.26032 3.64594C3.82225 3.69732 3.45094 3.97509 3.26904 4.36649L4.62931 4.99868ZM4.43987 5.13515L7.56475 4.74815L7.38039 3.25952L4.25551 3.64652L4.43987 5.13515ZM7.5652 4.74809C7.46952 4.76 7.383 4.71628 7.33591 4.64935L8.56277 3.78632C8.29754 3.40927 7.84574 3.2016 7.37993 3.25957L7.5652 4.74809ZM7.33434 4.6471L9.74941 8.1071L10.9794 7.24856L8.56434 3.78856L7.33434 4.6471ZM10.5506 8.40436C11.3042 8.21126 12.0922 8.21126 12.8459 8.40436L13.2182 6.9513C12.2203 6.69561 11.1761 6.69561 10.1783 6.9513L10.5506 8.40436ZM16.9653 9.69043C16.1722 8.44295 14.9801 7.51114 13.588 7.05771L13.1234 8.48396C14.1788 8.8277 15.09 9.53661 15.6995 10.4952L16.9653 9.69043ZM13.5889 7.05802C13.4664 7.01792 13.3424 6.9821 13.2171 6.95054L12.8508 8.40513C12.9426 8.42823 13.0331 8.45441 13.1225 8.48365L13.5889 7.05802ZM16.9695 10.4917L20.0524 5.58271L18.7822 4.78495L15.6992 9.69395L16.9695 10.4917ZM20.0535 5.58096C20.2822 5.21467 20.3095 4.75672 20.1282 4.36612L18.7677 4.99765C18.7363 4.9301 18.7405 4.85167 18.7811 4.78671L20.0535 5.58096ZM20.1282 4.36612C19.9462 3.97396 19.5741 3.69579 19.1352 3.64484L18.9623 5.13483C18.87 5.12412 18.7997 5.06677 18.7677 4.99765L20.1282 4.36612ZM19.1407 3.64549L16.0158 3.25949L15.8319 4.74818L18.9568 5.13418L19.1407 3.64549ZM16.0165 3.25957C15.5507 3.2016 15.0989 3.40927 14.8337 3.78632L16.0605 4.64935C16.0134 4.71628 15.9269 4.76 15.8312 4.74809L16.0165 3.25957ZM14.8321 3.78848L12.4171 7.24748L13.647 8.10619L16.062 4.64719L14.8321 3.78848Z" fill="#000000" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4714 11.5108L11.6982 10.0038L10.925 11.5108C10.8703 11.6208 10.7911 11.716 10.6939 11.7888C10.5964 11.8621 10.4836 11.911 10.3644 11.9318L8.77319 12.2528L9.88469 13.6158C10.0357 13.7865 10.1069 14.0161 10.0797 14.2448L9.87007 16.0038L11.3326 15.2768C11.4466 15.2205 11.5716 15.1915 11.6982 15.1918C11.816 15.192 11.932 15.2212 12.0365 15.2768L13.5361 15.9588L13.3245 14.2218C13.2973 13.9931 13.3685 13.7635 13.5195 13.5928L14.6232 12.2528L13.031 11.9328C12.9118 11.912 12.799 11.8631 12.7015 11.7898C12.6045 11.7166 12.5257 11.621 12.4714 11.5108Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </span> */}
                      <img
                        height={30}
                        src={noun_medal}
                        className="tabs_icon_img"
                        alt="icon"
                      />
                      {/* <img
                                                src={Networking_tab_icon}
                                                className="tabs_icon_img"
                                                alt="icon"
                                            /> */}
                    </div>
                    <div className="col-11 text-white custom-padding-why-join">
                      {/* <b>Celebrate Success:</b> Winners and top performers are recognized and celebrated through our website and media platforms, shining a spotlight on their dedication and achievements! */}
                      <b>Celebrate every achievement: </b>Winners and top
                      performers get recognized on our website and social media,
                      highlighting their hard work and achievements!
                    </div>
                  </div>
                  <div className="row pt-3 tab_content_row">
                    <div className="col-1">
                      {" "}
                      {/* <span className="tabs_icon_img"> */}
                      {/* <svg width="20px" height="35px" version="1.1" fill='white' viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="m960.94 604.55-178.03 135.98c-3.3281-6.5625-7.6406-12.75-12.703-18.375-16.641-18.281-41.062-28.828-67.078-29.016l-313.03-1.4062h-0.09375c-5.2031 0-10.359 1.6406-14.578 4.6875l-243.71 175.45c-16.781 12.094-27.703 30.047-30.797 50.484-3.0938 20.484 2.1094 40.828 14.672 57.281l68.484 90.188c14.859 19.594 37.547 30.141 60.656 30.141 13.312 0 26.766-3.5156 38.906-10.734l107.25-63.891 357.42-0.09375h0.79688c31.5 0 61.781-13.359 83.156-36.656l244.82-266.86c30.234-32.953 30.844-80.859 1.3594-111.47-29.719-30.844-81.281-33.328-117.42-5.7656zm79.172 83.438-244.82 266.86c-11.766 12.844-29.109 20.484-46.547 20.484h-0.42188l-364.45 0.09375c-4.5 0-8.9062 1.2188-12.797 3.5156l-113.16 67.406c-11.391 6.7969-26.109 3.9375-34.172-6.6562l-68.484-90.188c-4.3125-5.6719-6.0938-12.656-5.0156-19.688 1.0312-7.0312 4.7812-13.172 10.594-17.344l237.1-170.72 304.82 1.3594c12.234 0.09375 23.016 4.5938 30.328 12.656 6.4688 7.0781 9.5156 16.453 8.6719 26.297v0.09375c-2.0625 23.062-24.938 42.469-50.062 42.469h-0.32812l-228.66-1.5469h-0.1875c-13.734 0-24.891 11.062-24.984 24.844s11.016 25.078 24.844 25.172l228.66 1.5469h0.65625c46.688 0 88.219-33.234 98.016-76.453l201.52-153.89c16.266-12.469 38.719-12.094 51.047 0.65625 11.062 11.484 10.125 29.578-2.2031 42.984z" />
                                                        <path d="m715.18 105.47c-41.438-1.9688-82.406 10.969-115.17 35.906-32.766-24.938-73.594-37.828-115.17-35.906-50.109 2.3906-95.438 25.172-127.64 64.078-56.953 68.953-49.828 174.71 16.172 240.71l163.64 163.64c17.344 17.344 40.172 26.062 62.953 26.062 22.828 0 45.609-8.6719 62.953-26.062l163.64-163.64c66.047-66.047 73.125-171.74 16.172-240.71-32.156-38.953-77.484-61.688-127.64-64.078zm76.078 269.44-163.64 163.64c-15.234 15.188-39.984 15.188-55.219 0l-163.64-163.64c-48-48-53.719-124.22-12.984-173.53 23.062-27.938 55.547-44.297 91.453-45.984 2.0156-0.09375 3.9844-0.14062 5.9531-0.14062 33.281 0 65.531 13.266 89.156 36.891 9.7969 9.7969 25.594 9.7969 35.344 0 25.031-25.031 59.578-38.25 95.109-36.75 35.906 1.6875 68.344 18.047 91.453 45.984 40.734 49.312 35.016 125.53-12.984 173.53z" />
                                                    </svg> */}
                      {/* <svg width="23px" height="35px" viewBox="0 0 28 28" fill="white" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3057 18.2975L8.23724 19.987C5.47183 20.9088 4.08912 21.3697 3.35924 20.6398C2.62936 19.9099 3.09026 18.5272 4.01207 15.7618L5.70156 10.6933C6.46758 8.39525 6.85059 7.24623 7.75684 7.03229C8.6631 6.81835 9.51953 7.67478 11.2324 9.38764L14.6114 12.7666C16.3242 14.4795 17.1807 15.3359 16.9667 16.2422" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M12.2351 18.3461C12.2351 18.3461 11.477 16.0649 11.477 14.5552C11.477 13.0454 12.2351 10.7643 12.2351 10.7643M8.06517 19.4833C8.06517 19.4833 7.42484 16.7314 7.307 14.9343C7.11229 11.965 8.06517 7.35254 8.06517 7.35254" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M14.5093 10.0061L14.6533 9.28614C14.7986 8.55924 15.3224 7.96597 16.0256 7.73155C16.7289 7.49714 17.2526 6.90387 17.398 6.17697L17.542 5.45703" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M17.5691 12.2533L17.7819 12.3762C18.4391 12.7556 19.2652 12.6719 19.8329 12.1685C20.347 11.7126 21.0792 11.597 21.7087 11.8723L22.0002 11.9997" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M10.5352 3C10.1977 3.55206 10.2823 4.26344 10.7399 4.72097L10.8377 4.81885C11.2309 5.21201 11.3759 5.78959 11.215 6.32182" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
<path d="M13.561 4.39648C13.7621 4.19542 13.8626 4.09489 13.9788 4.05804C14.0772 4.02688 14.1827 4.02688 14.281 4.05804C14.3973 4.09489 14.4978 4.19542 14.6989 4.39648C14.8999 4.59753 15.0004 4.69806 15.0373 4.8143C15.0685 4.91262 15.0685 5.01817 15.0373 5.11648C15.0004 5.23272 14.8999 5.33325 14.6989 5.53431C14.4978 5.73536 14.3973 5.83589 14.281 5.87274C14.1827 5.90391 14.0772 5.90391 13.9788 5.87274C13.8626 5.83589 13.7621 5.73536 13.561 5.53431C13.36 5.33325 13.2594 5.23272 13.2226 5.11648C13.1914 5.01817 13.1914 4.91262 13.2226 4.8143C13.2594 4.69806 13.36 4.59753 13.561 4.39648Z" fill="#1C274C"/>
<path d="M19.4682 7.46822C19.7136 7.22283 19.8363 7.10014 19.9747 7.04681C20.1367 6.9844 20.3161 6.9844 20.4781 7.04681C20.6165 7.10014 20.7392 7.22283 20.9846 7.46822C21.23 7.71362 21.3527 7.83631 21.406 7.97472C21.4684 8.1367 21.4684 8.31609 21.406 8.47807C21.3527 8.61649 21.23 8.73918 20.9846 8.98457C20.7392 9.22996 20.6165 9.35266 20.4781 9.40599C20.3161 9.4684 20.1367 9.4684 19.9747 9.40599C19.8363 9.35266 19.7136 9.22996 19.4682 8.98457C19.2228 8.73918 19.1001 8.61649 19.0468 8.47807C18.9844 8.31609 18.9844 8.1367 19.0468 7.97472C19.1001 7.83631 19.2228 7.71362 19.4682 7.46822Z" fill="#1C274C"/>
<path d="M6.92737 3.94079C7.13683 3.73132 7.47645 3.73132 7.68592 3.94079C7.89539 4.15026 7.89539 4.48988 7.68592 4.69935C7.47645 4.90882 7.13683 4.90882 6.92737 4.69935C6.7179 4.48988 6.7179 4.15026 6.92737 3.94079Z" fill="#1C274C"/>
<path d="M19.0582 15.3134C19.2677 15.1039 19.6073 15.1039 19.8168 15.3134C20.0262 15.5228 20.0262 15.8624 19.8168 16.0719C19.6073 16.2814 19.2677 16.2814 19.0582 16.0719C18.8488 15.8624 18.8488 15.5228 19.0582 15.3134Z" fill="#1C274C"/>
<path d="M17.5 9.74145C17.7095 9.53198 18.0491 9.53198 18.2586 9.74145C18.468 9.95092 18.468 10.2905 18.2586 10.5C18.0491 10.7095 17.7095 10.7095 17.5 10.5C17.2905 10.2905 17.2905 9.95092 17.5 9.74145Z" fill="#1C274C"/>
</svg> */}
                      {/* </span> */}
                      {/* <img
                                                src={office_tab_icon}
                                                className="tabs_icon_img"
                                                alt="icon"
                                            /> */}
                      <img
                        height={30}
                        src={noun_networking}
                        className="tabs_icon_img"
                        alt="icon"
                      />
                    </div>
                    <div className="col-11 text-white custom-padding-why-join">
                      {/* <b> Play Hard, Win Big:</b> Challenge yourself for a chance to win cash prizes, medals, and trophies, while showcasing your suburb’s strength and talent! */}
                      <b> Make new connections: </b> Meet like-minded players,
                      form friendships, and enjoy a sporting experience like no
                      other!
                    </div>
                  </div>
                  <div className="row pt-3 tab_content_row">
                    <div className="col-1">
                      {" "}
                      <img
                        height={30}
                        src={noun_money_bag}
                        className="tabs_icon_img"
                        alt="icon"
                      />
                      {/* <span className="tabs_icon_img">
                                            <svg width="23px" height="35px" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7255 17.1019C11.6265 16.8844 11.4215 16.7257 11.1734 16.6975C10.9633 16.6735 10.7576 16.6285 10.562 16.5636C10.4743 16.5341 10.392 16.5019 10.3158 16.4674L10.4424 16.1223C10.5318 16.1622 10.6239 16.1987 10.7182 16.2317L10.7221 16.2331L10.7261 16.2344C11.0287 16.3344 11.3265 16.3851 11.611 16.3851C11.8967 16.3851 12.1038 16.3468 12.2629 16.2647L12.2724 16.2598L12.2817 16.2544C12.5227 16.1161 12.661 15.8784 12.661 15.6021C12.661 15.2955 12.4956 15.041 12.2071 14.9035C12.062 14.8329 11.8559 14.7655 11.559 14.6917C11.2545 14.6147 10.9987 14.533 10.8003 14.4493C10.6553 14.3837 10.5295 14.279 10.4161 14.1293C10.3185 13.9957 10.2691 13.7948 10.2691 13.5319C10.2691 13.2147 10.3584 12.9529 10.5422 12.7315C10.7058 12.5375 10.9381 12.4057 11.2499 12.3318C11.4812 12.277 11.6616 12.1119 11.7427 11.8987C11.8344 12.1148 12.0295 12.2755 12.2723 12.3142C12.4751 12.3465 12.6613 12.398 12.8287 12.4677L12.7122 12.8059C12.3961 12.679 12.085 12.6149 11.7841 12.6149C10.7848 12.6149 10.7342 13.3043 10.7342 13.4425C10.7342 13.7421 10.896 13.9933 11.1781 14.1318L11.186 14.1357L11.194 14.1393C11.3365 14.2029 11.5387 14.2642 11.8305 14.3322C12.1322 14.4004 12.3838 14.4785 12.5815 14.5651L12.5856 14.5669L12.5897 14.5686C12.7365 14.6297 12.8624 14.7317 12.9746 14.8805L12.9764 14.8828L12.9782 14.8852C13.0763 15.012 13.1261 15.2081 13.1261 15.4681C13.1261 15.7682 13.0392 16.0222 12.8604 16.2447C12.7053 16.4377 12.4888 16.5713 12.1983 16.6531C11.974 16.7163 11.8 16.8878 11.7255 17.1019Z" fill="#000000"/>
<path d="M11.9785 18H11.497C11.3893 18 11.302 17.9105 11.302 17.8V17.3985C11.302 17.2929 11.2219 17.2061 11.1195 17.1944C10.8757 17.1667 10.6399 17.115 10.412 17.0394C10.1906 16.9648 9.99879 16.8764 9.83657 16.7739C9.76202 16.7268 9.7349 16.6312 9.76572 16.5472L10.096 15.6466C10.1405 15.5254 10.284 15.479 10.3945 15.5417C10.5437 15.6262 10.7041 15.6985 10.8755 15.7585C11.131 15.8429 11.3762 15.8851 11.611 15.8851C11.8129 15.8851 11.9572 15.8628 12.0437 15.8181C12.1302 15.7684 12.1735 15.6964 12.1735 15.6021C12.1735 15.4929 12.1158 15.411 12.0004 15.3564C11.8892 15.3018 11.7037 15.2422 11.4442 15.1777C11.1104 15.0933 10.8323 15.0039 10.6098 14.9096C10.3873 14.8103 10.1936 14.6514 10.0288 14.433C9.86396 14.2096 9.78156 13.9092 9.78156 13.5319C9.78156 13.095 9.91136 12.7202 10.1709 12.4074C10.4049 12.13 10.7279 11.9424 11.1401 11.8447C11.2329 11.8227 11.302 11.7401 11.302 11.6425V11.2C11.302 11.0895 11.3893 11 11.497 11H11.9785C12.0862 11 12.1735 11.0895 12.1735 11.2V11.6172C12.1735 11.7194 12.2487 11.8045 12.3471 11.8202C12.7082 11.8777 13.0255 11.9866 13.2989 12.1469C13.3765 12.1924 13.4073 12.2892 13.3775 12.3756L13.0684 13.2725C13.0275 13.3914 12.891 13.4417 12.7812 13.3849C12.433 13.2049 12.1007 13.1149 11.7841 13.1149C11.4091 13.1149 11.2216 13.2241 11.2216 13.4425C11.2216 13.5468 11.2773 13.6262 11.3885 13.6809C11.4998 13.7305 11.6831 13.7851 11.9386 13.8447C12.2682 13.9192 12.5464 14.006 12.773 14.1053C12.9996 14.1996 13.1953 14.356 13.3602 14.5745C13.5291 14.7929 13.6136 15.0908 13.6136 15.4681C13.6136 15.8851 13.4879 16.25 13.2365 16.5628C13.0176 16.8354 12.7145 17.0262 12.3274 17.1353C12.2384 17.1604 12.1735 17.2412 12.1735 17.3358V17.8C12.1735 17.9105 12.0862 18 11.9785 18Z" fill="#000000"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.59235 5H13.8141C14.8954 5 14.3016 6.664 13.8638 7.679L13.3656 8.843L13.2983 9C13.7702 8.97651 14.2369 9.11054 14.6282 9.382C16.0921 10.7558 17.2802 12.4098 18.1256 14.251C18.455 14.9318 18.5857 15.6958 18.5019 16.451C18.4013 18.3759 16.8956 19.9098 15.0182 20H8.38823C6.51033 19.9125 5.0024 18.3802 4.89968 16.455C4.81587 15.6998 4.94656 14.9358 5.27603 14.255C6.12242 12.412 7.31216 10.7565 8.77823 9.382C9.1696 9.11054 9.63622 8.97651 10.1081 9L10.0301 8.819L9.54263 7.679C9.1068 6.664 8.5101 5 9.59235 5Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.2983 9.75C13.7125 9.75 14.0483 9.41421 14.0483 9C14.0483 8.58579 13.7125 8.25 13.2983 8.25V9.75ZM10.1081 8.25C9.69391 8.25 9.35812 8.58579 9.35812 9C9.35812 9.41421 9.69391 9.75 10.1081 9.75V8.25ZM15.9776 8.64988C16.3365 8.44312 16.4599 7.98455 16.2531 7.62563C16.0463 7.26671 15.5878 7.14336 15.2289 7.35012L15.9776 8.64988ZM13.3656 8.843L13.5103 9.57891L13.5125 9.57848L13.3656 8.843ZM10.0301 8.819L10.1854 8.08521L10.1786 8.08383L10.0301 8.819ZM8.166 7.34357C7.80346 7.14322 7.34715 7.27469 7.1468 7.63722C6.94644 7.99976 7.07791 8.45607 7.44045 8.65643L8.166 7.34357ZM13.2983 8.25H10.1081V9.75H13.2983V8.25ZM15.2289 7.35012C14.6019 7.71128 13.9233 7.96683 13.2187 8.10752L13.5125 9.57848C14.3778 9.40568 15.2101 9.09203 15.9776 8.64988L15.2289 7.35012ZM13.2209 8.10709C12.2175 8.30441 11.1861 8.29699 10.1854 8.08525L9.87486 9.55275C11.0732 9.80631 12.3086 9.81521 13.5103 9.57891L13.2209 8.10709ZM10.1786 8.08383C9.47587 7.94196 8.79745 7.69255 8.166 7.34357L7.44045 8.65643C8.20526 9.0791 9.02818 9.38184 9.88169 9.55417L10.1786 8.08383Z" fill="#000000"/>
</svg>
                                            </span> */}
                    </div>
                    <div className="col-11 text-white custom-padding-why-join">
                      {/* <b> Make a Difference:</b> A portion of the registration fees will go to meaningful charities, allowing you to create a positive impact on lives while competing! */}
                      <b> Win exciting prizes: </b> Get rewarded for your
                      efforts - play for cash prizes, medals, and more!
                    </div>
                  </div>
                  <div className="row pt-3 tab_content_row">
                    <div className="col-1">
                      {" "}
                      {/*  <img
                                                src={charity_tab_icon}
                                                className="tabs_icon_img"
                                                alt="icon"
                                            // /> */}
                      <span className="tabs_icon_img">
                        <svg
                          width="24px"
                          height="35px"
                          version="1.1"
                          fill="white"
                          viewBox="0 0 1200 1200"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="m960.94 604.55-178.03 135.98c-3.3281-6.5625-7.6406-12.75-12.703-18.375-16.641-18.281-41.062-28.828-67.078-29.016l-313.03-1.4062h-0.09375c-5.2031 0-10.359 1.6406-14.578 4.6875l-243.71 175.45c-16.781 12.094-27.703 30.047-30.797 50.484-3.0938 20.484 2.1094 40.828 14.672 57.281l68.484 90.188c14.859 19.594 37.547 30.141 60.656 30.141 13.312 0 26.766-3.5156 38.906-10.734l107.25-63.891 357.42-0.09375h0.79688c31.5 0 61.781-13.359 83.156-36.656l244.82-266.86c30.234-32.953 30.844-80.859 1.3594-111.47-29.719-30.844-81.281-33.328-117.42-5.7656zm79.172 83.438-244.82 266.86c-11.766 12.844-29.109 20.484-46.547 20.484h-0.42188l-364.45 0.09375c-4.5 0-8.9062 1.2188-12.797 3.5156l-113.16 67.406c-11.391 6.7969-26.109 3.9375-34.172-6.6562l-68.484-90.188c-4.3125-5.6719-6.0938-12.656-5.0156-19.688 1.0312-7.0312 4.7812-13.172 10.594-17.344l237.1-170.72 304.82 1.3594c12.234 0.09375 23.016 4.5938 30.328 12.656 6.4688 7.0781 9.5156 16.453 8.6719 26.297v0.09375c-2.0625 23.062-24.938 42.469-50.062 42.469h-0.32812l-228.66-1.5469h-0.1875c-13.734 0-24.891 11.062-24.984 24.844s11.016 25.078 24.844 25.172l228.66 1.5469h0.65625c46.688 0 88.219-33.234 98.016-76.453l201.52-153.89c16.266-12.469 38.719-12.094 51.047 0.65625 11.062 11.484 10.125 29.578-2.2031 42.984z" />
                          <path d="m715.18 105.47c-41.438-1.9688-82.406 10.969-115.17 35.906-32.766-24.938-73.594-37.828-115.17-35.906-50.109 2.3906-95.438 25.172-127.64 64.078-56.953 68.953-49.828 174.71 16.172 240.71l163.64 163.64c17.344 17.344 40.172 26.062 62.953 26.062 22.828 0 45.609-8.6719 62.953-26.062l163.64-163.64c66.047-66.047 73.125-171.74 16.172-240.71-32.156-38.953-77.484-61.688-127.64-64.078zm76.078 269.44-163.64 163.64c-15.234 15.188-39.984 15.188-55.219 0l-163.64-163.64c-48-48-53.719-124.22-12.984-173.53 23.062-27.938 55.547-44.297 91.453-45.984 2.0156-0.09375 3.9844-0.14062 5.9531-0.14062 33.281 0 65.531 13.266 89.156 36.891 9.7969 9.7969 25.594 9.7969 35.344 0 25.031-25.031 59.578-38.25 95.109-36.75 35.906 1.6875 68.344 18.047 91.453 45.984 40.734 49.312 35.016 125.53-12.984 173.53z" />
                        </svg>
                      </span>
                    </div>
                    <div className="col-11 text-white custom-padding-why-join">
                      {/* <b> Compete for Glory:</b> Leave your mark! Your performance not only shapes the tournament’s legacy but also becomes part of your personal journey as an athlete! */}
                      <b> Play with purpose: </b> A portion of the registration
                      fees will go to charity, ensuring that you create a
                      positive impact on the community!
                    </div>
                  </div>
                  <div className="row pt-3 tab_content_row">
                    <div className="col-1">
                      {" "}
                      <img
                        height={30}
                        src={noun_bright_star}
                        className="tabs_icon_img"
                        alt="icon"
                      />
                      {/* <img
                                                src={Visibility_tab_icon}
                                                className="tabs_icon_img"
                                                alt="icon"
                                            /> */}
                      {/* <span className="tabs_icon_img">
                                            <svg width="20px" height="35px" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
</svg>

                                            </span> */}
                    </div>
                    <div className="col-11 text-white custom-padding-why-join">
                      {/* <b>Experience Quality Competition:</b> Test your skills against top-notch competitors in a vibrant arena filled with talent. Push yourself in an environment designed to bring out your best! */}
                      <b>Enjoy a great atmosphere: </b> Compete in a friendly,
                      well-organized tournament where the love of the game
                      brings everyone together!
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="custom-tabs-1 ">
                            <ul className="nav nav-tabs" id="myTab1" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active"
                                        id="home-tab1"
                                        data-bs-toggle="tab"
                                        data-bs-target="#home1"
                                        type="button"
                                        role="tab"
                                        aria-controls="home1"
                                        aria-selected="true"
                                    >
                                        United Benefits
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="profile-tab1"
                                        data-bs-toggle="tab"
                                        data-bs-target="#profile1"
                                        type="button"
                                        role="tab"
                                        aria-controls="profile1"
                                        aria-selected="false"
                                    >
                                        Individual Benefits
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent1">
                                <div
                                    className="tab-pane fade show active"
                                    id="home1"
                                    role="tabpanel"
                                    aria-labelledby="home-tab1"
                                >
                                    <div className="row py-5">
                                        <div className="col-lg-6 text-white">
                                            <div className="tabs_img_div">
                                                <img
                                                    src={tabs1_content_img}
                                                    className="large_tab_img"
                                                    alt="tennis bat"
                                                />
                                                <img
                                                    src={tabs_content_people_play_img}
                                                    className="small_tab_img"
                                                    alt="play"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="main_tab_right">
                                                <div className="row tab_right_block">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Productivity_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Enhanced Productivity: </b>Improved mental and
                                                        physical health from regular sports participation leads to
                                                        higher productivity levels and better performance,
                                                        benefiting the company's output and efficiency.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Networking_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b>Professional Networking:</b> Employee interactions with
                                                        peers from other organizations can lead to valuable
                                                        industry connections, knowledge exchange, and potential
                                                        partnerships, benefiting the company by fostering
                                                        strategic relationships and gaining industry insights.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={office_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Office Engagement:</b> By encouraging employees to
                                                        return to the office and participate in team events, the
                                                        tournament trengthens workplace relationships and fosters
                                                        a more engaged and cohesive team environment.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Bragging_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Bragging Rights: </b>Corporations compete for an
                                                        overall trophy, creating a sense of pride and achievement
                                                        within the winning team, thereby enhancing employee
                                                        satisfaction and loyalty.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={charity_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Charity Contributions: </b> Portions of the proceeds
                                                        support renowned charities like Plant with Purpose, Red
                                                        Cross, and Cancer Council, reflecting the company’s
                                                        commitment to social responsibility.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Visibility_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Brand Visibility:</b> Media exposure and tournament
                                                        participation elevate the company’s profile, showcasing
                                                        its commitment to employee wellness and community
                                                        involvement.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="profile1"
                                    role="tabpanel"
                                    aria-labelledby="profile-tab1"
                                >
                                    <div className="row py-5">
                                        <div className="col-lg-6 text-white">
                                            <div className="tabs_img_div">
                                                <img
                                                    src={tabs1_content_img}
                                                    className="large_tab_img"
                                                    alt="tennis bat"
                                                />
                                                <img
                                                    src={tabs_content_people_play_img}
                                                    className="small_tab_img"
                                                    alt="play"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="main_tab_right">
                                                <div className="row tab_right_block">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Productivity_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Enhanced Well-being: </b>Engaging in sports promotes better mental and physical health,
                                                        contributing to increased personal productivity and overall job satisfaction.

                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Networking_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b>Professional Networking:</b> Employees have the chance to network and build
                                                        relationships with colleagues from their own and other organizations, fostering a sense
                                                        of community as well as enhancing career development and professional skills.

                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={office_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Achievement Recognition:</b> Winners and top performers receive recognition within their
                                                        corporations and through media platforms, celebrating their achievements.

                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Bragging_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Valuable Incentives:  </b>Attractive rewards, including prize money, medals, and trophies,
                                                        motivate participants to excel and perform their best.

                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={charity_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Charity Contributions: </b> Participation in the tournament supports valuable charities such
                                                        as Plant with Purpose, Red Cross, and Cancer Council, allowing individuals to contribute
                                                        to meaningful causes while enjoying the event.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Visibility_tab_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Records & Statistics: </b> Detailed records and statistics encourage serious and
                                                        competitive participation, enhancing the event's prestige.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={Healthy_tab2_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Healthy Rivalries:  </b>The tournament fosters a competitive spirit and healthy rivalries
                                                        among participants, encouraging them to improve and strive for excellence.
                                                    </div>
                                                </div>
                                                <div className="row pt-3">
                                                    <div className="col-1">
                                                        {" "}
                                                        <img
                                                            src={quality_tab2_icon}
                                                            className="tabs_icon_img"
                                                            alt="icon"
                                                        />
                                                    </div>
                                                    <div className="col-11 text-white">
                                                        <b> Quality Competition:  </b>Participants get to test their skills against high-caliber opponents,
                                                        ensuring a challenging and rewarding experience.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </section>
        {/* <section className="container-fluid letsplay_main_sec py-5 ">
                    <div className="container ">
                        <div className="row lets_play_bg">
                            <div className="col-lg-6 text-white letplay_response">
                                <p className="lets_play_color"> LET’S PLAY TOGETHER</p>
                                <h3>
                                    {" "}
                                    Lead, Innovate, Succeed Dive into the Premier
                                    <br className='mobile_hide' />
                                    United Strategy Game
                                </h3>
                                <p>
                                    {" "}
                                    Unleash your team's potential in an engaging United strategy game!
                                    Collaborate to tackle challenges, innovate solutions, and drive success.
                                    Strengthen leadership skills, enhance problem-solving abilities, and
                                    build a cohesive team dynamic—all while having fun. Are you ready to
                                    lead your team to victory?
                                </p>
                            </div>
                            <div className="col-lg-6"></div>
                        </div>
                    </div>
                </section> */}
        {Tournament.length > 0 ? (
          <section className="container-fluid tournament_block pt-5 pb-3 ">
            <div className="container">
              <div className="custom-tabs-1 ">
                <ul className="nav nav-tabs d-block" id="myTab1" role="tablist">
                  <div className="tournament_tab_btn_filtr_maindiv">
                    <div className="d-flex tournament_hometab_btn">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="tournament_deatail_tab1"
                          data-bs-toggle="tab"
                          data-bs-target="#tournament_deatail1"
                          type="button"
                          role="tab"
                          aria-controls="home1"
                          aria-selected="true"
                        >
                          TOURNAMENT DETAILS
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="team_deatail-tab1"
                          data-bs-toggle="tab"
                          data-bs-target="#team_deatail1"
                          type="button"
                          role="tab"
                          aria-controls="profile1"
                          aria-selected="false"
                        >
                          TEAM DETAILS
                        </button>
                      </li>
                    </div>
                    <div className="filter_btn_tournament">
                      {/* static city button  */}
                      <div>
                        <div className="top_perform_txt response_tournament ms-3">
                          City
                        </div>
                        <CFormSelect
                          aria-label="Default select example"
                          // onChange={handleTeamChange}
                          className="bg-dark text-white table_selctbtn_standing"
                        >
                          <option value="city-1">Melbourne</option>
                        </CFormSelect>
                      </div>
                      {/* static tournament button  */}
                      <div>
                        <div className="top_perform_txt response_tournament ms-3">
                          Tournament
                        </div>
                        <CFormSelect
                          aria-label="Default select example"
                          // onChange={handleTeamChange}
                          className="bg-dark text-white table_selctbtn_standing"
                        >
                          {selectedTournament != null ? (
                            <option value={selectedTournament}>
                              {selectedTournament}{" "}
                            </option>
                          ) : null}
                        </CFormSelect>
                      </div>
                    </div>
                  </div>
                </ul>
                <div className="tab-content" id="myTabContent1">
                  <div
                    className="tab-pane fade show active"
                    id="tournament_deatail1"
                    role="tabpanel"
                    aria-labelledby="tournament_deatail_tab1"
                  >
                    <Row className="my-3">
                      {Tournament.length > 0
                        ? Tournament.map((entry, index) => (
                            <>
                              <div className="space_card_infor_div">
                                <div className="tournament_info_main">
                                  <div className="  tourment_info text-white ps-2 pe-2">
                                    <img
                                      src={calender_icon_info}
                                      alt="calender icon"
                                    />
                                    <p className="mb-0 ps-1">
                                      November 2025
                                      {/* {FormatDate(entry.start_date, 0, 0, 1)}
                                                                            {' - '}
                                                                            {FormatDate(entry.end_date, 0, 0, 1)} */}
                                    </p>
                                  </div>
                                  <div className="  tourment_info text-white ps-2 pe-2">
                                    <img
                                      src={locatioon_icon_info}
                                      alt="calender icon"
                                    />
                                    <p className="mb-0 ps-1">
                                      {entry.location}
                                    </p>
                                  </div>
                                  <div className=" tourment_info text-white ps-2 pe-2">
                                    <img
                                      src={user_icon_info}
                                      alt="calender icon"
                                    />
                                    <p className="mb-0 ps-1">
                                      {" "}
                                      {entry.no_of_teams + "    Teams"}
                                    </p>
                                  </div>
                                  <div className=" tourment_info text-white ps-2 pe-2">
                                    <img
                                      src={game_icon_info}
                                      alt="calender icon"
                                    />
                                    <p className="mb-0 ps-2"> 2 Games</p>
                                  </div>
                                </div>
                              </div>
                              <div className="row pt-4 m-0 d-flex justify-content-center">
                                {/* <div className="col-lg-3 ">
                                                                        <div className="tournament_cart">
                                                                            <div className="image_div">
                                                                                <img
                                                                                    src={tournament_cart_img2}
                                                                                    className="card_img"
                                                                                    alt="cart_img"
                                                                                />
                                                                                <p className="cart_tag">Bowling</p>
                                                                            </div>
                                                                            <div className="row card_deatails_tournment pt-2">
                                                                                <div className="col-2 pe-0">
                                                                                    <img
                                                                                        src={calendar_icon_cart}
                                                                                        alt="icon"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-10 cartinfo_text ps-0">

                                                                                    {FormatDate(entry.bowling_start_date, 0, 0, 1)}
                                                                                    {' - '}
                                                                                    {FormatDate(entry.bowling_end_date, 0, 0, 1)}

                                                                                </div>
                                                                            </div>
                                                                            <div className="row card_deatails_tournment">
                                                                                <div className="col-2 pe-0">
                                                                                    <img
                                                                                        src={user_icon_cart}
                                                                                        alt="icon"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-10 cartinfo_text ps-0">
                                                                                    {" "}
                                                                                1,200 participants (Men & Women)
                                                                                </div>
                                                                            </div>
                                                                            <div className="row card_deatails_tournment">
                                                                                <div className="col-2 pe-0">
                                                                                    <img
                                                                                        src={location_icon_cart}
                                                                                        alt="icon"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-10 cartinfo_text ps-0">
                                                                                Strike Bowling QV
                                                                                </div>
                                                                            </div>
                                                                            <div className='d-flex justify-content-start bowling-cart-bottom'>
                                                                                <button className='download_icon_div'>
                                                                                    <i class="bi bi-download "
                                                                                    onClick={() => {
                                                                                        const filteredDocuments = allPDF.filter(doc => doc.document_type === "bowling_rules");
                                                                                        console.log(filteredDocuments);
                                                                                    if (filteredDocuments.length) {

                                                                                        window.open(PDF_URL + filteredDocuments[0].filename, '_blank');
                                                                                    }

                                                                                        // Add any other logic to handle the filtered documents
                                                                                    }}
                                                                                    ></i>
                                                                                </button>
                                                                                <span className="tourment_cart_content">
                                                                                Download the rules and tournament structure for Bowling here.
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                                <div className="col-lg-3">
                                  <div className="tournament_cart">
                                    <div className="image_div">
                                      <img
                                        src={tournament_cart_img3}
                                        className="card_img"
                                        alt="cart_img"
                                      />
                                      <p className="cart_tag">Table Tennis</p>
                                    </div>
                                    <div className="row card_deatails_tournment pt-2">
                                      <div className="col-2 pe-0">
                                        <img
                                          src={calendar_icon_cart}
                                          alt="icon"
                                        />
                                      </div>
                                      <div className="col-10 cartinfo_text ps-0">
                                        {/* {FormatDate(entry.table_tenis_start_date, 0, 0, 1)}
                                                                                    {' - '}
                                                                                    {FormatDate(entry.table_tenis_end_date, 0, 0, 1)} */}
                                        08/11/2025 - 09/11/2025
                                      </div>
                                    </div>
                                    <div className="row card_deatails_tournment">
                                      <div className="col-2 pe-0">
                                        <img src={user_icon_cart} alt="icon" />
                                      </div>
                                      <div className="col-10 cartinfo_text ps-0">
                                        {" "}
                                        96 participants (Men & Women)
                                      </div>
                                    </div>
                                    <div className="row card_deatails_tournment">
                                      <div className="col-2 pe-0">
                                        <img
                                          src={location_icon_cart}
                                          alt="icon"
                                        />
                                      </div>
                                      <div className="col-10 cartinfo_text ps-0">
                                        Melbourne Sports & Aquatic Centre (MSAC)
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-start ">
                                      <button className="download_icon_div">
                                        <i
                                          class="bi bi-download "
                                          onClick={() => {
                                            const filteredDocuments =
                                              allPDF.filter(
                                                (doc) =>
                                                  doc.document_type ===
                                                  "table_tenis_rules"
                                              );
                                            console.log(filteredDocuments);
                                            if (filteredDocuments.length) {
                                              window.open(
                                                PDF_URL +
                                                  filteredDocuments[0].filename,
                                                "_blank"
                                              );
                                            }

                                            // Add any other logic to handle the filtered documents
                                          }}
                                        ></i>
                                      </button>
                                      <span className="tourment_cart_content">
                                        Download the rules and tournament
                                        structure for Table Tennis here.
                                        {/* Fast-paced and skillful matches that challenge reflexes. */}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-3">
                                  <div className="tournament_cart">
                                    <div className="image_div">
                                      <img
                                        src={tournament_cart_img1}
                                        className="card_img"
                                        alt="cart_img"
                                      />
                                      <p className="cart_tag">Badminton</p>
                                    </div>
                                    <div className="row card_deatails_tournment pt-2">
                                      <div className="col-2 pe-0">
                                        <img
                                          src={calendar_icon_cart}
                                          alt="icon"
                                        />
                                      </div>
                                      <div className="col-10 cartinfo_text ps-0">
                                        22/11/2025 - 23/11/2025
                                        {/* {FormatDate(entry.badminton_start_date, 0, 0, 1)}
                                                                                    {' - '}
                                                                                    {FormatDate(entry.badminton_end_date, 0, 0, 1)} */}
                                      </div>
                                    </div>
                                    <div className="row card_deatails_tournment">
                                      <div className="col-2 pe-0">
                                        <img src={user_icon_cart} alt="icon" />
                                      </div>
                                      <div className="col-10 cartinfo_text ps-0">
                                        {" "}
                                        96 participants (Men &amp; Women)
                                      </div>
                                    </div>
                                    <div className="row card_deatails_tournment">
                                      <div className="col-2 pe-0">
                                        <img
                                          src={location_icon_cart}
                                          alt="icon"
                                        />
                                      </div>
                                      <div className="col-10 cartinfo_text ps-0">
                                        {/* Melbourne Sports & Aquatic Centre (MSAC) */}
                                        Melbourne Sports & Aquatic Centre (MSAC)
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-start ">
                                      <button className="download_icon_div">
                                        <i
                                          class="bi bi-download "
                                          onClick={() => {
                                            const filteredDocuments =
                                              allPDF.filter(
                                                (doc) =>
                                                  doc.document_type ===
                                                  "badminton_rules"
                                              );
                                            console.log(filteredDocuments);
                                            if (filteredDocuments.length) {
                                              window.open(
                                                PDF_URL +
                                                  filteredDocuments[0].filename,
                                                "_blank"
                                              );
                                            }

                                            // Add any other logic to handle the filtered documents
                                          }}
                                        ></i>
                                      </button>
                                      <span className="tourment_cart_content">
                                        Download the rules and tournament
                                        structure for Badminton here.
                                        {/* High energy games that require agility and precision */}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-lg-3">
                                                                        <div className="tournament_cart">
                                                                            <div className="image_div">
                                                                                <img
                                                                                    src={tournament_cart_img4}
                                                                                    className="card_img"
                                                                                    alt="cart_img"

                                                                                />
                                                                                <p className="cart_tag">2K Run</p>
                                                                            </div>
                                                                            <div className="row card_deatails_tournment pt-2">
                                                                                <div className="col-2 pe-0">
                                                                                    <img
                                                                                        src={calendar_icon_cart}
                                                                                        alt="icon"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-10 cartinfo_text ps-0">

                                                                                    {FormatDate(entry.twok_run_start_date, 0, 0, 1)}
                                                                                    {' - '}
                                                                                    {FormatDate(entry.twok_run_end_date, 0, 0, 1)}


                                                                                </div>
                                                                            </div>
                                                                            <div className="row card_deatails_tournment">
                                                                                <div className="col-2 pe-0">
                                                                                    <img
                                                                                        src={user_icon_cart}
                                                                                        alt="icon"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-10 cartinfo_text ps-0">
                                                                                    {" "}
                                                                                    1,600 participants (Men &amp; Women)
                                                                                </div>
                                                                            </div>
                                                                            <div className="row card_deatails_tournment">
                                                                                <div className="col-2 pe-0">
                                                                                    <img
                                                                                        src={location_icon_cart}
                                                                                        alt="icon"
                                                                                    />
                                                                                </div>
                                                                                <div className="col-10 cartinfo_text ps-0">
                                                                                    {" "}
                                                                                    State Sports Centres - Lakeside Stadium
                                                                                </div>
                                                                            </div>
                                                                            <div className='d-flex justify-content-start'>
                                                                                <button className='download_icon_div'>
                                                                                <i class="bi bi-download "
                                                                                    onClick={() => {
                                                                                        const filteredDocuments = allPDF.filter(doc => doc.document_type === "twok_run_rules");
                                                                                        console.log(filteredDocuments);
                                                                                    if (filteredDocuments.length) {

                                                                                        window.open(PDF_URL + filteredDocuments[0].filename, '_blank');
                                                                                    }

                                                                                        // Add any other logic to handle the filtered documents
                                                                                    }}>
                                                                                    </i>
                                                                                </button>
                                                                                <span className="tourment_cart_content">
                                                                                Download the rules and tournament structure for 2K Run here
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div> */}
                              </div>
                            </>
                          ))
                        : null}
                    </Row>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="team_deatail1"
                    role="tabpanel"
                    aria-labelledby="team_deatail-tab1"
                  >
                    <Row className="my-3">
                      <Row className="m-0">
                        {teams.length > 0
                          ? teams.map((Entry, index) => (
                              <Col lg={3} xs={6} key={index}>
                                <div className="team_deatail_col_tab_home text-white">
                                  <img
                                    src={IMAGE_URL + "teams/" + Entry.logo}
                                    className="teamtab_logo_landingpge"
                                    alt="logo_img"
                                  />
                                  {/* <div className='team_deatail_tab_text'>{Entry.domain}</div> */}
                                </div>
                              </Col>
                            ))
                          : null}
                      </Row>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : null}
        {/*peter */}
        <section className="container-fluid tabs_main_sec pb-5 ">
          <div className="container">
            <h3 className="text-white mt-2 new_all_common_heading">PARTNERS</h3>
            <div>
              {/* 1 block */}
              <Row className="my-3">
                {/* <Row className='m-0'> */}

                <h5 className="text-white mt-4 mb-3">
                  PROUDLY AFFILIATED WITH STATE SPORTING BODIES
                </h5>
                <Col md={3} xs={12}>
                  <div className="team_deatail_col_tab_home text-white affiliated_img_div">
                    <a href="https://www.badmintonvic.com.au" target="_blank">
                      <img
                        src={bandminton_img}
                        className="teamtab_logo_landingpge_badminton"
                        alt="logo_img"
                      />
                    </a>
                  </div>
                </Col>

                <Col md={3} xs={12}>
                  <div className="team_deatail_col_tab_home text-white affiliated_img_div">
                    <a href="https://www.tabletennisvic.org.au" target="_blank">
                      {" "}
                      <img
                        src={table_tennis_img}
                        className="teamtab_logo_landingpge_badminton"
                        alt="logo_img"
                      />
                    </a>
                  </div>
                </Col>
                <div className="d-flex align-items-start mt-4 mb-3">
                  <span
                    style={{
                      color: "orange",
                      fontWeight: "bold",
                      marginRight: "2px",
                      fontSize: "14px",
                    }}
                  >
                    *
                  </span>
                  <p
                    className="text-white mb-0 mobile-side-font"
                    style={{ fontSize: "14px", marginTop: "-1px" }}
                  >
                    This tournament is independently organised by us, One Vision
                    Sports Pty Ltd. While we are proudly affiliated with the
                    state sporting bodies mentioned above, all correspondence
                    regarding the tournament should be directed to our team.
                  </p>
                </div>

                {/* </Row> */}
              </Row>
              <Row className="my-3">
                {/* <Row className='m-0'> */}
                <h5 className="text-white mt-4 mb-3">
                  PROUDLY SUPPORTING LEADING CHARITIES
                </h5>
                {/* <Col lg={3} xs={6}>
                                                                    <div className='team_deatail_col_tab_home text-white'>
                                                                         <img
                                                                            src={cancer_council_vic}
                                                                            className='teamtab_logo_landingpge'
                                                                            alt='logo_img'
                                                                        /> 
                                                                           
                                                                    </div>
                                                                </Col>
                                                      */}
                <Col xs={12}>
                  <div className="team_deatail_col_tab_home text-white cancer_img_div">
                    <a href="https://www.cancervic.org.au" target="_blank">
                      <img
                        src={cancer_counsil}
                        className="teamtab_logo_landingpge_cancer"
                        alt="logo_img"
                      />{" "}
                    </a>
                  </div>
                </Col>

                {/* </Row> */}
              </Row>
            </div>
          </div>
        </section>

        {/*  */}
        {/* <section className="container-fluid faq_block pt-5 pb-3" id="faqs">
                    <div className="container">
                        <h3 className="fw-bold text-white pb-4">
                            Frequently Asked Questions
                        </h3>
                        <div id="accordionPanelsStayOpenExample1" class="accordion m-auto ">
                            {
                                allFaq.length > 0 ? (
                                    allFaq.map((faq, index) => (
                                        <div class="accordion-item">
                                            <div class="accordion-header">
                                                <button type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpen-collapse${index}`}
                                                    aria-expanded="true" aria-controls={`panelsStayOpen-collapse${index}`} class="accordion-button collapsed">
                                                    {faq.question}
                                                </button>
                                            </div>
                                            <div id={`panelsStayOpen-collapse${index}`} data-bs-parent="#accordionPanelsStayOpenExample1"
                                                class="accordion-collapse collapse">
                                                <div class="accordion-body">
                                                    {faq.answer}
                                                </div>
                                            </div>
                                        </div>

                                    )

                                    )

                                ) : null
                            }

                        </div>
                    </div>
                </section> */}
        <Footer />
        {/* <footer className="container-fluid footer_main_sec pb-2 pt-2  ">
                    <div className="footer_div">
                        ©&nbsp;Copyright&nbsp;United Premier Games&nbsp;All Rights Reserved.
                        <a href="/privacy&policy"> Privacy Policy</a>
                        <span> | </span>
                        <a href="/terms&condition"> Terms & Conditions</a>
                    </div>
                </footer> */}
      </div>
    </>
  );
};
export default Home;
